import script from "./guangyingGuoke.vue?vue&type=script&setup=true&lang=js"
export * from "./guangyingGuoke.vue?vue&type=script&setup=true&lang=js"

import "./guangyingGuoke.vue?vue&type=style&index=0&id=5f37c215&lang=scss&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f37c215"]])

export default __exports__